export const isDevelopmentMode = () => {
  return process.env.NX_SERVER === 'develop';
};

export const isStagingtMode = () => {
  return process.env.NX_SERVER === 'staging';
};

export const isProductionMode = () => {
  return process.env.NX_SERVER === 'production';
};
export const isAdyenLiveMode = () => {
  return process.env.NX_ADYEN_ENVIRONMENT === 'live';
};
